import { render } from "./NerpathamPayments.vue?vue&type=template&id=781a8546&scoped=true"
import script from "./NerpathamPayments.vue?vue&type=script&lang=js"
export * from "./NerpathamPayments.vue?vue&type=script&lang=js"

import "./NerpathamPayments.vue?vue&type=style&index=0&id=781a8546&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781a8546"]])

export default __exports__